define(
'@discoveryedu/platform-pages/i18nPluralTerms',{
  "%(count)d Change": "%(count)d Changes",
  "%(count)d Lesson": "%(count)d Lessons",
  "%(count)d Word": "%(count)d Words",
  "%(count)d min": "%(count)d mins",
  "%(count)d minute": "%(count)d minutes",
  "%(count)d Minute": "%(count)d Minutes",
  "%(count)d Student to Add": "%(count)d Students to Add",
  "Displaying <b>%(count)d</b> result for:": "Displaying <b>%(count)d</b> results for:",
  "You have <span class=\"archive-classrooms-modal__classname\">%(count)d</span> class that was created over 12 months ago.": "You have <span class=\"archive-classrooms-modal__classname\">%(count)d</span> classes that were created over 12 months ago.",
  "You just archived %(count)d class. Would you like to archive more classes?": "You just archived %(count)d classes. Would you like to archive more classes?",
  "%(count)d new student was added": "%(count)d new students were added",
  "%(student)s was successfully added to %(classname)s and assigned %(count)d assignment.": "%(student)s was successfully added to %(classname)s and assigned %(count)d assignments.",
  "(%(count)d Student)": "(%(count)d Students)",
  "Successfully assigned to %(count)d class!": "Successfully assigned to %(count)d classes!",
  "%(num)s Result for <span>%(search_term)s</span>": "%(num)s Results for <span>%(search_term)s</span>",
  "%(num)s Result": "%(num)s Results",
  "%(count)d Question": "%(count)d Questions",
  "%(count)d pt": "%(count)d pts",
  "%(count)d point": "%(count)d points",
  "%(score)s / %(count)d pt": "%(score)s / %(count)d pts",
  "%(score)s / %(count)d point": "%(score)s / %(count)d points",
  "__/%(count)d pt": "__/%(count)d pts",
  "%(score)d/%(count)d pt": "%(score)d/%(count)d pts",
  "%(count)d/%(total)d Selected Student": "%(count)d/%(total)d Selected Students",
  "<b>%(numDisplay)s</b> Result for <b>%(keyword)s</b>": "<b>%(numDisplay)s</b> Results for <b>%(keyword)s</b>",
  "<b>%(numDisplay)s</b> Result": "<b>%(numDisplay)s</b> Results",
  "<b>%(numDisplay)s</b> Result for <b>&ldquo;%(keyword)s&rdquo;</b> and <b>%(standard)s</b>": "<b>%(numDisplay)s</b> Results for <b>&ldquo;%(keyword)s&rdquo;</b> and <b>%(standard)s</b>",
  "You have completed %(answeredCount)d out of %(count)d question on this assignment. Do you wish to submit your answers?": "You have completed %(answeredCount)d out of %(count)d questions on this assignment. Do you wish to submit your answers?"
}
)
;
